import { CatButton } from '@blocks-react/components/Button';
import { StoreContactButtonProps } from './types';
import { FC } from 'react';

export const StoreContactButton:FC<StoreContactButtonProps> = (props) => {
  const { label, href } = props;

  return (
    <CatButton href={href} className="my-3">
      {label}
    </CatButton>
  );
};
